var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"fdd-checkbox",attrs:{"for":_vm.switchId}},[_c('input',{attrs:{"id":_vm.switchId,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"checkbox"}),_c('span',{staticClass:"bg"},[_c('i',[_vm._v(_vm._s(_vm.activeText))]),_c('i',[_vm._v(_vm._s(_vm.inactiveText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }